import { BaseError } from '../../_base/lang/BaseError';

// La API rechazó la reserva por una regla de negocio. El mensaje está pensado
// para mostrárselo tal cual al usuario.
export class BookingRejectedError extends BaseError {}
